import { GoJsModelProperties, hasDiagramDarkMode } from '@y42/gojs';
import { Binding, GraphObject, Node, Part } from 'gojs';
import {
  DataLineageNodeBinding,
  DataLineageThemeColors,
  DataLineageUINode,
} from '../../../../../../state/data-lineage-diagram';
import { shouldHighlight } from '../../../utils/data-lineage-highlight';

export const nodeBackgroundBinding = () =>
  new Binding('fill', '', (node: DataLineageUINode, diagramPart: Part) => {
    const hasDarkMode = hasDiagramDarkMode(diagramPart.diagram);
    const hasReadPermission = node[DataLineageNodeBinding.HasReadPermission];

    if (hasDarkMode) {
      return hasReadPermission ? DataLineageThemeColors.Dark.NodeFill : DataLineageThemeColors.Dark.NodeFillDisabled;
    }

    return hasReadPermission ? DataLineageThemeColors.Light.NodeFill : DataLineageThemeColors.Light.NodeFillDisabled;
  });

export const nodeStrokeBinding = () =>
  new Binding('stroke', '', (object: GraphObject, diagramPart: Part) => {
    const node = object.part as Node;
    const nodeData = node.data as DataLineageUINode | undefined;

    const hasDarkMode = diagramPart.diagram?.model.modelData[GoJsModelProperties.HasDarkMode];

    if (!nodeData?.[DataLineageNodeBinding.Name]) {
      return DataLineageThemeColors.Transparent;
    }

    const filterHighlights = object.diagram?.model.modelData[DataLineageNodeBinding.FilterHighlights] || [];
    const canHighlight = shouldHighlight(filterHighlights, node);

    if (node.isHighlighted) {
      return hasDarkMode
        ? DataLineageThemeColors.Dark.Stroke.Highlighted
        : DataLineageThemeColors.Light.Stroke.Highlighted;
    }

    if (nodeData?.[DataLineageNodeBinding.Active]) {
      return hasDarkMode ? DataLineageThemeColors.Dark.Stroke.Active : DataLineageThemeColors.Light.Stroke.Active;
    }

    if (node.isSelected) {
      return hasDarkMode ? DataLineageThemeColors.Dark.Stroke.Selected : DataLineageThemeColors.Light.Stroke.Selected;
    }

    if (nodeData?.[DataLineageNodeBinding.PathSelection]) {
      return hasDarkMode
        ? DataLineageThemeColors.Dark.Stroke.PathSelection
        : DataLineageThemeColors.Light.Stroke.PathSelection;
    }

    if (filterHighlights.length > 0 && canHighlight) {
      return hasDarkMode
        ? DataLineageThemeColors.Dark.Stroke.FilterHighlight
        : DataLineageThemeColors.Light.Stroke.FilterHighlight;
    }

    if (nodeData?.[DataLineageNodeBinding.Peeked]) {
      return hasDarkMode ? DataLineageThemeColors.Dark.Stroke.Peeked : DataLineageThemeColors.Light.Stroke.Peeked;
    }

    return hasDarkMode ? DataLineageThemeColors.Dark.NodeStroke : DataLineageThemeColors.Light.NodeStroke;
  }).ofObject();
